/**
 * Availability window state/source enum schemas.
 *
 * Traceability: availability-windows / Requirement: Availability window
 * state/source schemas and permission.
 */
import { z } from 'zod';

export const AvailabilityWindowStateSchema = z.enum(['FREE', 'UNAVAILABLE']);
export type AvailabilityWindowState = z.infer<typeof AvailabilityWindowStateSchema>;

export const AvailabilityWindowSourceSchema = z.enum([
  'xlsx_import',
  'manual_admin',
  'provider_override',
]);
export type AvailabilityWindowSource = z.infer<typeof AvailabilityWindowSourceSchema>;
